import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Support } from "~/domains";
import { NotFound } from "~/sections";
import { ROUTES } from "./constants";

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Support />} path={ROUTES.support} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
